var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialHandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.528 7.63703C11.2232 7.05383 11.1553 6.37531 11.3385 5.7432C11.5217 5.11108 11.9418 4.57427 12.5111 4.24489C13.0804 3.91551 13.7548 3.81903 14.3935 3.97562C15.0322 4.13221 15.5857 4.52975 15.9385 5.08519L19.7626 11.7072",
    stroke: "#2b451e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39854 11.8575L6.47411 8.36894C6.18652 7.79329 6.12247 7.12355 6.29533 6.49963C6.4682 5.8757 6.86462 5.34584 7.40178 5.02072C7.93894 4.69561 8.57529 4.60039 9.17792 4.75495C9.78054 4.90951 10.3028 5.30189 10.6357 5.85014L14.7251 13.268",
    stroke: "#2b451e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2289 20.6138C18.9026 20.0436 18.6904 19.4137 18.6047 18.7603C18.519 18.1068 18.5613 17.4427 18.7293 16.8058C18.8973 16.169 19.1876 15.572 19.5836 15.0492C19.9796 14.5263 20.4735 14.0878 21.037 13.7589L19.7986 11.5743C19.4701 10.9966 19.3815 10.3103 19.5522 9.66636C19.7229 9.02241 20.139 8.47358 20.7088 8.1406C21.2787 7.80763 21.9557 7.71779 22.591 7.89084C23.2262 8.0639 23.7676 8.48567 24.096 9.06338L26.573 13.4199C27.8868 15.7274 28.2426 18.4695 27.5621 21.0429C26.8816 23.6164 25.2205 25.8104 22.9443 27.1423C20.668 28.4742 17.9631 28.8349 15.4246 28.145C12.886 27.4551 10.7217 25.7712 9.40789 23.4637L4.20636 14.3238C4.04372 14.0378 3.93825 13.7221 3.89598 13.3947C3.85371 13.0673 3.87545 12.7347 3.95998 12.4159C4.13069 11.7719 4.54675 11.2231 5.11662 10.8901C5.6865 10.5571 6.36352 10.4673 6.99874 10.6403C7.63396 10.8134 8.17536 11.2352 8.50382 11.8129L11.2284 16.5963",
    stroke: "#2b451e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0751 30.0491C8.3253 28.83 6.86867 27.2297 5.81262 25.3662",
    stroke: "#2b451e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7001 3.90237C22.8792 3.8994 24.0381 4.18669 25.059 4.73503C26.0799 5.28338 26.9265 6.07323 27.5126 7.02429",
    stroke: "#2b451e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialHandIcon);
export default __webpack_public_path__ + "static/media/social-hand-icon.dcc872079f0d94406506b21bcfa54891.svg";
export { ForwardRef as ReactComponent };